import React, { ReactElement, RefObject, RefCallback } from 'react';
import SelectionInput from './SelectionInput';
import { Checkbox as componentName } from './name';
import Icon from '../Icon/Icon';

export type TCheckbox = {
  /** value of the checkbox dom input*/
  value: string;
  /** The id of the checkbox input, also used on the label as htmlFor */
  id?: string;
  /** Whether or not it is checked */
  isChecked: boolean;
  /** The label text. Also passed into aria-label attribute on the input itself*/
  labelText: string;
  // ** Count of items in a formatted string */
  counter?: string;
  /** Only visible on mobile + stacked */
  icon?: string;
  /** Only visible on mobile + stacked */
  helperText?: string;
  /** On component change */
  onChange?: React.FormEventHandler<HTMLInputElement>;
  className?: string;
  /** External `ref` */
  inputRef?: RefObject<HTMLInputElement> | RefCallback<HTMLInputElement>;
  disabled?: boolean;
  ariaLabel?: string;
  badgeLabel?: string;
  assetName?: string;
  name?: string;
  /**
   * Due to limitation in react and possible conflicts with the `checked` state,
   * A custom DOM mutation is required for this to work. please refer the related story.
   * https://github.com/facebook/react/issues/1798
   */
  isIndeterminate?: boolean;
} & React.HTMLAttributes<any>;

const CheckMark = () => <Icon name="checkmark" color="background-default" />;
const IndeterminateIcon = () => <Icon name="minus" color="background-default" />;

const Checkbox = ({
  value,
  id,
  labelText,
  isChecked,
  counter,
  icon,
  helperText,
  inputRef,
  ariaLabel,
  onChange,
  badgeLabel = '',
  assetName = '',
  ...rest
}: TCheckbox): ReactElement => (
  <SelectionInput
    isChecked={isChecked}
    value={value}
    labelText={labelText}
    counter={counter}
    componentName={componentName}
    icon={icon}
    onChange={onChange}
    id={id}
    helperText={helperText}
    CheckMark={CheckMark}
    IndeterminateIcon={IndeterminateIcon}
    inputRef={inputRef}
    ariaLabel={ariaLabel}
    badgeLabel={badgeLabel}
    assetName={assetName}
    {...rest}
  />
);

export default Checkbox;
